import type {
  FormattedFinanceStatus,
  FormattedStatus,
} from "components/job/JobTable/types";
import { getLabel } from "components/job/JobTable/Activity/helpers";
import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface ActivityPropsHookArgs {
  date: string;
  status: FormattedStatus;
  financeStatus: FormattedFinanceStatus;
  archived: string;
}

export interface ActivityPropsHook {
  label: string;
  timestamp: number;
  searchWords?: string[];
  status: string;
  financeStatus: string;
}

export default function useActivityProps({
  date,
  status,
  financeStatus,
  archived,
}: ActivityPropsHookArgs): ActivityPropsHook {
  const [query] = useQuery("jobs");

  const searchWords = useSearchWords(query);

  const timestamp = new Date(date).getTime();

  const label =
    archived === "no" ? getLabel(status, financeStatus) : "Archived";

  const statusLabel = status
    ? `Status: ${status?.replace("_", " ")?.toUpperCase()}`
    : "";

  const financeLabel = status
    ? `Finance: ${financeStatus?.replace(/_/g, " ")?.toUpperCase()}`
    : "";

  return {
    label,
    timestamp,
    searchWords,
    status: statusLabel,
    financeStatus: financeLabel,
  };
}
